export const LOAD_DASHBOARD_ALERT_RULE_SETS_SUCCESS = 'LOAD_DASHBOARD_ALERT_RULE_SETS_SUCCESS';

export const ALERT_TYPE_RANGE = 'range';
export const ALERT_TYPE_PERCENT = 'percent';
export const alertTypeNameMapping = {
    [ALERT_TYPE_RANGE]: "Range",
    [ALERT_TYPE_PERCENT]: "Percent",
}